import Axios from 'axios';

export default {

    getSportFixtures() {
        return Axios.get(`/api/liveinplay/sports`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(error);
        })
    },
    getEventCounts() {
        return Axios.get(`/api/liveinplay/geteventcounts`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(error);
        })
    }
}